import { Future } from '@hds/common-utils';

class ChangeEventsWritableStream {
    #_controller;
    #_writer;
    #_writable;
    #_changeProcessor;
    #_initializingFuture;
    constructor(changeProcessorFn) {
        this.#_changeProcessor = changeProcessorFn;
        this.#_initializingFuture = new Future();
    }
    /*****************************************************/
    /* START OVERRIDABLE METHODS */
    /*****************************************************/
    async _initialize() {
        this.#_writable = new WritableStream(
            {
                start: (controller) => { return this._start(controller) },
                write: (chunk, controller) => { return this._write(chunk, controller) },
                close: (controller) => { return this._close(controller) },
                abort: (reason) => { return this._abort(reason) },
            },
            {
                // this defines the total number of chunks that can be contained in the internal queue before backpressure is applied.
                // Essentially turn off backpressure for writing to the "underlying sink"
                highWaterMark: Number.MAX_SAFE_INTEGER,
            }
        );
        return this.#_initializingFuture.promise;
    }
    // called once, immediately after the WritableStream is constructed.
    //Inside this method, you should include code that sets up the stream functionality, e.g.getting access to the underlying sink.
    async _start(controller) {
        this.#_controller = controller;
        this.#_initializingFuture.resolve();
    }
    //is called repeatedly every time a new chunk is ready to be written to the underlying sink(specified in the chunk parameter).
    async _write(chunk, controller) {
        await this.#_changeProcessor(chunk);
    }
    // called if the app signals that it has finished writing chunks to the stream.
    // It should do whatever is necessary to finalize writes to the underlying sink, and release access to it.
    async _close(controller) {

        this.#_initializingFuture = null;
    }
    //called if the app signals that it wishes to abruptly close the stream and put it in an errored state.
    async _abort(reason) {
        this.#_initializingFuture = null;
        return reason;
    }
    /*****************************************************/
    /* END OVERRIDABLE METHODS */
    /* START WRITABLE METHODS */
    /*****************************************************/
    async close() {
        if (this.#_writer) {
            return this.#_writer.close();
        }
        else {
            return this.#_writable.close();
        }
    }
    async abort(reason) {
        if (this.#_writer) {
            return this.#_writer.abort(reason);
        }
        else {
            return this.#_writable.abort(reason);
        }
    }
    getWriter() {
        if (!this.#_writer) {
            this.#_writer = this.#_writable.getWriter();
        }
        return this.#_writer;
    }
    /*****************************************************/
    /* END READABLE METHODS */
    /*****************************************************/
    isInitialized() {
        return this.#_initializingFuture.isCompleted()
    }
    async whenInitialized() {
        return this._initialize();
    }
    get writableStream() {
        return this.#_writable;
    }
}
export { ChangeEventsWritableStream };
export default ChangeEventsWritableStream; ``